

























import { Component, Prop, Vue, Ref } from 'vue-property-decorator';

export interface InputOption {
    text: string
    action: () => void
}

@Component
export default class InputDialog extends Vue {
    @Ref("input") readonly input!: HTMLInputElement
    title?: string
    value?: string
    placeholder?: string
    positive?: InputOption
    negative?: InputOption
    data() {
        return {
            title: null,
            value: null,
            placeholder: null,
            positive: null,
            negative: null,
        }
    }
    show(title: string, value: string, placeholder: string, positive?: InputOption, negative?: InputOption) {
        this.title = title
        this.value = value
        this.placeholder = placeholder
        this.positive = positive
        this.negative = negative
        var el: any = $(this.$el)
        el.modal('show')
        el.on('shown.bs.modal', () => {
            this.input.select()
            this.input.focus()
        })      
    }
    submit() {
        this.onPositiveClick()
        var el: any = $(this.$el)
        el.modal('hide')
    }
    onPositiveClick() {
        if (this.positive) {
            this.positive.action()
        }
    }
    onNegativeClick() {
        if (this.negative) {
            this.negative.action()
        }
    }
}
